/**
 * Created by desheng.zhao on 2019/2/21.
 */
import en from "./en"
import zh from "./zh"
import zhTW from "./zh-TW"

import Vue from "vue"
import VueI18n from "vue-i18n"
import cookie from "../utils/cookie"
Vue.use(VueI18n);

const messages = {
  "zh-CN": zh,
  "en-US": en,
  "zh-TW": zhTW
};
const dateFormate = {
  "zh-CN": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    }
  },
  "en-US": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  }
};
const defaultLanguage = "zh-CN";
// var localLang = localStorage.getItem("language");
var localLang = cookie.get("lang");
let language = localLang || defaultLanguage;
var lang;
switch (language){
  case "zh-CN":
    lang = "zh-CN";
    break;
  case "en-US":
    lang = "en-US";
    break;
  case "zh-TW":
    lang = "zh-TW";
    break;
  default: lang = "zh-CN";
}
// var lang = language == "zh" ? "zh-CN" : "en-US";
cookie.set("lang", lang, {expires: 365, path: '/'});
// !localLang && localStorage.setItem("language", language);
// !localLang && cookie.set("lang", language);

const i18n = new VueI18n({
  locale: language,
  messages: messages,
  dateTimeFormats: dateFormate,//日期格式化$d
  fallbackLocale: "zh-CN"
});

export default i18n;




// WEBPACK FOOTER //
// ./src/lang/index.js